import { EDeviceModel } from '@web/entities/connections/model/enums'
import type {
  IDeviceModelOption
} from '@web/entities/device/model/device.interface'
import { EPhysicalType } from '@web/entities/point'
import { DeviceLabel } from '@web/shared/constants/devices-form.constant'

export const deviceModelOptions: IDeviceModelOption[] = [
  {
    label: DeviceLabel.VP3701,
    value: EDeviceModel.VP3701,
    availableFor: [
      EPhysicalType.TEMPERATURE,
      EPhysicalType.VIBRO_ACCELERATION,
      EPhysicalType.VIBRO_DISPLACEMENT,
      EPhysicalType.VIBRO_VELOCITY
    ]
  },
  {
    label: DeviceLabel.Ltr24,
    value: EDeviceModel.LTR24,
    availableFor: [
      EPhysicalType.VOLTAGE,
      EPhysicalType.VIBRO_ACCELERATION,
      EPhysicalType.VIBRO_ACCELERATION,
      EPhysicalType.VIBRO_DISPLACEMENT,
      EPhysicalType.VIBRO_VELOCITY,
      EPhysicalType.AMPERAGE
    ]
  },
  {
    label: DeviceLabel.Ltr51,
    value: EDeviceModel.LTR51,
    availableFor: [EPhysicalType.RPM, EPhysicalType.DRPM]
  },
  {
    label: DeviceLabel.LtrSync,
    value: EDeviceModel.LTR_SYNC,
    availableFor: [EPhysicalType.RPM]
  },
  {
    label: DeviceLabel.Generator,
    value: EDeviceModel.GENERATOR,
    availableFor: [
      EPhysicalType.VOLTAGE,
      EPhysicalType.AMPERAGE,
      EPhysicalType.VIBRO_ACCELERATION,
      EPhysicalType.VIBRO_DISPLACEMENT,
      EPhysicalType.VIBRO_VELOCITY,
      EPhysicalType.RPM
    ]
  },
  {
    label: DeviceLabel.Controller,
    value: EDeviceModel.CONTROLLER,
    availableFor: [EPhysicalType.TEMPERATURE]
  }
]

export const enum Vp3701Label {
  Vp3701Id = 'VP-3701 ID',
  SerialNumber = 'Серийный номер',
  PowerType = 'Источник питания',
  Version = 'Версия',
  IP = 'IP-адрес',
  Name = 'Наименование устройства',
  ConnectionStatus = 'Статус подключения к ТИ',
  StatusUpdatingTimestamp = 'Время обновления статуса',
  Status = 'Статус соединения',
  PortData = 'Порт данных',
  PortSetting = 'Порт потока'
}

export const GeneratorLabel = {
  GeneratorId: 'Генератор-ID',
  Name: 'Наименование',
  Type: 'Тип',
  Fs: 'Частота дискретизации, Гц',
  NormAmp: `Предельная амплитуда`,
  NameSignal: 'Наименование сигнала',
  SquareBaseFreq: 'Базовая частота, Гц',
  SquareLowLevel: 'Нижний уровень',
  SquareHighToLow: 'Размах, %',
  SquareDuty: 'Длительность, сек.',
  SquarePhase: 'Начальная фаза, %',
  DskSettings: 'DskSettings',
  AmpSet: 'Амплитуда распределения',
  BaseAmp: 'Амплитуда базовой частоты',
  BaseFreq: 'Базовая частота, Гц',
  Dclevel: 'Постоянная составляющая',
  LastAmp: 'Амплитуда посл. гарм., %',
  M1_AmpSet: 'Закон изменения ряда',
  M1_BaseFreq: 'Базовая частота, Гц',
  M1_DeepA: 'Глубина модуляции ампл., %А',
  M1_DeepT: 'Глубина модуляции фазовая, %А',
  M1_LastAmp: 'Глубина модул. посл. гарм., %',
  M1_Nharm: 'Количество гармоник',
  M1_PhaseSet: 'Фазовое распределение',
  M1_Type: 'Тип модуляции',
  M1_PhaseShift: 'Сдвиг по фазе, град',
  M2_AmpSet: 'Закон изменения ряда',
  M2_BaseFreq: 'Базовая частота, Гц',
  M2_DeepA: 'Глубина модуляции ампл., %А',
  M2_DeepT: 'Глубина модуляции фазовая, %А',
  M2_LastAmp: 'Глубина модул. посл. гарм., %',
  M2_Nharm: 'Количество гармоник',
  M2_PhaseSet: 'Фазовое распределение',
  M2_PhaseShift: 'Сдвиг по фазе, град',
  M2_Type: 'Тип модуляции',
  Nharm: 'Количество гармоник',
  PhaseSet: 'Фазовое распределение',
  PhaseShift: 'Сдвиг по фазе, град',
  WhiteNoise: 'Уровень белого шума, %'
} as const

export type TGeneratorLabel =
  (typeof GeneratorLabel)[keyof typeof GeneratorLabel]
